import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedQuizType: cacheLs.get_quiz_type()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
